export default __webpack_public_path__ + "static/hpBanner-401fda39d0111178c3ba5f88ec1dd63f.jpg";